var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "add_svg__svg-safari-fix",
  viewBox: "0 0 16.667 16.667",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.333 16.667A8.333 8.333 0 1 0 8.333 0a8.333 8.333 0 0 0 0 16.667M8.321 3.975c.46-.002.834.37.835.83l.008 2.692 2.692-.008a.833.833 0 1 1 .005 1.667l-2.692.008.008 2.692a.833.833 0 0 1-1.667.005l-.008-2.693-2.692.008a.833.833 0 0 1-.005-1.667l2.693-.007L7.49 4.81a.833.833 0 0 1 .83-.835",
  clipRule: "evenodd"
})));
export default SvgAdd;